import PropTypes from "prop-types";
import React from "react";
import { questionTypes } from "../../../constants/index";
import MultipleChoiceFields from "./MultipleChoiceFields";
import FillInTheBlankFields from "./FillInTheBlankFields";
import TrueOrFalseFields from "./TrueOrFalseFields";
import { reorder } from "../../../utils/tableUtils";
import { v4 as uuid } from "uuid";
import OrderingFields from "./OrderingFields";
import MatchingFields from "./MatchingFields";
import LongAnswerFields from "./LongAnswerFields";
import ShortAnswerFields from "./ShortAnswerFields";
import MultiSelectFields from "./MultiSelectFields";

const QuestionTypeFields = ({
  answers,
  disabled,
  questionType,
  isSurveyQuestion,
  questionFilesList,
  setQuestionFilesList,
  onAnswersChange
}) => {
  const handleCorrectAnswerChange = correctAnswerIndex => {
    const newAnswers = answers.map((answer, index) => ({
      ...answer,
      correct: index === correctAnswerIndex
    }));
    onAnswersChange(newAnswers);
  };

  const handleAnswerTextChange = (newAnswerText, answerIndex) => {
    let newAnswers = [...answers];
    newAnswers[answerIndex].text = newAnswerText;

    onAnswersChange(newAnswers);
  };
  const handleReorderAnswers = reorderedAnswers => {
    // dropped outside the list
    if (!reorderedAnswers.destination) {
      return;
    }
    const newAnswers = reorder(
      answers,
      reorderedAnswers.source.index,
      reorderedAnswers.destination.index
    );
    newAnswers.forEach(function(el, i) {
      el.order = i;
    });
    onAnswersChange(newAnswers);
  };

  const handleAddNewAnswerResponse = () => {
    onAnswersChange([
      ...answers,
      {
        text: "",
        correct: false,
        type: "answer",
        id: uuid(),
        order: answers.length
      }
    ]);
  };

  const handleDeleteAnswer = deletedAnswerIndex => {
    answers.splice(deletedAnswerIndex, 1);
    answers = answers.map((answer, order) => ({
      ...answer,
      order
    }));
    onAnswersChange(answers);
  };

  switch (questionType) {
    case questionTypes.trueFalse:
      return (
        <TrueOrFalseFields
          isSurvey={isSurveyQuestion}
          disabled={disabled}
          answers={answers}
          onCorrectAnswerChange={handleCorrectAnswerChange}
          questionFilesList={questionFilesList}
          setQuestionFilesList={setQuestionFilesList}
        />
      );
    case questionTypes.fillBlanks:
      return <FillInTheBlankFields isSurveyQuestion={isSurveyQuestion} />;
    case questionTypes.ordering:
      return (
        <OrderingFields
          isSurveyQuestion={isSurveyQuestion}
          questionFilesList={questionFilesList}
          setQuestionFilesList={setQuestionFilesList}
        />
      );
    case questionTypes.matching:
      return (
        <MatchingFields
          isSurveyQuestion={isSurveyQuestion}
          questionFilesList={questionFilesList}
          setQuestionFilesList={setQuestionFilesList}
        />
      );
    case questionTypes.multiSelect:
      return (
        <MultiSelectFields
          isSurveyQuestion={isSurveyQuestion}
          questionFilesList={questionFilesList}
          setQuestionFilesList={setQuestionFilesList}
          onReorderAnswers={handleReorderAnswers}
          onDelete={handleDeleteAnswer}
        />
      );
    case questionTypes.shortAnswer:
      return (
        <ShortAnswerFields
          isSurveyQuestion={isSurveyQuestion}
          questionFilesList={questionFilesList}
          setQuestionFilesList={setQuestionFilesList}
        />
      );
    case questionTypes.longAnswer:
      return (
        <LongAnswerFields
          questionFilesList={questionFilesList}
          setQuestionFilesList={setQuestionFilesList}
        />
      );
    default:
      return (
        <MultipleChoiceFields
          disabled={disabled}
          onCorrectAnswerChange={handleCorrectAnswerChange}
          onAnswerTextChange={handleAnswerTextChange}
          onReorderAnswers={handleReorderAnswers}
          onAddAnswer={handleAddNewAnswerResponse}
          isSurveyQuestion={isSurveyQuestion}
          questionFilesList={questionFilesList}
          setQuestionFilesList={setQuestionFilesList}
          onDelete={handleDeleteAnswer}
        />
      );
  }
};

QuestionTypeFields.propTypes = {
  disabled: PropTypes.bool,
  answers: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      correct: PropTypes.bool
    })
  ),
  questionType: PropTypes.oneOf(Object.values(questionTypes)),
  onChange: PropTypes.func,
  isSurveyQuestion: PropTypes.bool,
  questionFilesList: PropTypes.array,
  setQuestionFilesList: PropTypes.func
};

export default QuestionTypeFields;
